import { render, staticRenderFns } from "./HowToMakeWithdrawal.vue?vue&type=template&id=03b728d9&scoped=true&"
import script from "./HowToMakeWithdrawal.vue?vue&type=script&lang=js&"
export * from "./HowToMakeWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b728d9",
  null
  
)

export default component.exports